import React, { PropsWithChildren } from "react";
import {
  View,
  Platform,
  TextInput,
  StyleSheet,
  TextInputProps,
} from "react-native";
import Icon from "components/Icon";
import Text from "components/Text";

import { sizes, colors } from "assets/constants";
import fonts from "assets/fonts";
import { sn } from "utils";

const TextArea = (props: PropsWithChildren<TextInputT & TextInputProps>) => {
  const { lang, icon, style, inputRef, leftComponent, hideError, error } =
    props;

  return (
    <>
      <View style={{ ...styles.container, ...style }}>
        {leftComponent}
        <TextInput
          multiline
          ref={inputRef}
          {...(props as TextInputProps)}
          style={{
            ...styles.input,

            fontFamily: lang ? fonts[lang].default : fonts.fa.default,
          }}
          placeholderTextColor={colors.placeholder}
        />
        <View style={styles.iconContainer}>
          {icon && <Icon size={22} {...icon} style={{ bottom: 4 }} />}
        </View>
      </View>
      {!hideError && (
        <View style={styles.errorContainer}>
          <Text size={"xs"} color={colors.danger}>
            {error}
          </Text>
        </View>
      )}
    </>
  );
};

export default TextArea;

const styles = StyleSheet.create({
  container: {
    width: "100%",
    height: 120,
    borderWidth: 1,
    overflow: "hidden",
    flexDirection: "row",
    justifyContent: "flex-end",
    borderColor: colors.border,
    borderRadius: sizes.radius.xl,
    backgroundColor: colors.itemsBg,
    alignItems: "flex-start",
  },

  iconContainer: {
    aspectRatio: 1,
    width: 48,
    alignItems: "center",
    justifyContent: "center",
  },

  labelContainer: {
    width: "100%",
    alignItems: "flex-end",
  },

  input: {
    textAlignVertical: "top",
    fontSize: 14,
    flex: 1,
    width: "100%",
    height: "100%",
    lineHeight: 22,
    textAlign: "right",
    paddingLeft: 5,
    paddingRight: 2,
    paddingTop: sn(6, 8, 11, 12),
    color: colors.textColorDefault,
    ...Platform.select({
      web: {
        outlineColor: colors.transparent,
      },
    }),
  },

  errorContainer: {
    width: "100%",
    alignSelf: "flex-end",
    height: 20,
    marginBottom: 10,
    paddingHorizontal: 5,
    bottom: Platform.OS === "web" ? -2 : 3,
  },
});
